<template>
  <div id="app">
	  <transition :name="animate">
	    <router-view id="view"></router-view>
    </transition>
    <loading v-if="loadingShow"></loading>
  </div>
</template>

<script>
export default {
  name: 'App',
  data () {
      return {
        animate : '',
        loadingShow:""
    }
  },
  watch : {
    $route (to , from) {
      /*
       0: 不做动画
       1: 左切换
       2: 右切换
       3: 上切换
       4: 下切换
       */
      let animate = this.$router.animate || to.meta.slide

      if(!animate) {
        this.animate = 'slide'
      } else {
        this.animate = animate === 1 ? 'slide-left' :
          animate === 2 ?  'slide-right' :
          animate === 3 ?  'slide-top' :
          animate === 4 ?  'slide-bottom' : ''
      }

      if(to.meta.bankbtn){
        this.$router.bankbtn = to.meta.bankbtn
      }else {
        this.$router.bankbtn = 0
      }
      this.$router.animate = 0
    },
    loading(newVal,oldVal){
    	this.loadingShow = this.$store.state.showLoading
    }
  },
  computed:{
  	loading(){
  		return this.$store.state.showLoading
    }
  },
  created(){
    if(Boolean(this.$store.state.user.token)){
      this.getPermissions()
    }
    this.judgePlatform()
  },
  methods:{
    judgePlatform(){
      let device = ''
      var ua = window.navigator.userAgent.toLowerCase(); //微信
      var u = navigator.userAgent; //手机类型android或ios
      if (ua.match(/MicroMessenger/i) == 'micromessenger') { //微信
        device = 'wx'
      }
      else{
        device = 'other'
      }
      this.$store.commit('Login',{
        deviceType:device
      })
    }
  }
}
</script>

<style>
#app{
	height: 100%;
}
#view{
  position:  absolute;
  left:  0;
  top:  0;
  width:  100%;
  height:  100%;
  transition:  all .3s cubic-bezier(0.55, 0, 0.1, 1);
}
.slide-enter, .slide-leave-active{
  transition : opacity .25s;
}
.slide-leave-active, .slide-enter{

  opacity: 0;
}
.slide-left-enter, .slide-right-leave-active{

  opacity:  0;
  transform:  translate(100%, 0);
}
.slide-left-leave-active, .slide-right-enter{

  opacity: 0;
  transform: translate(-100%, 0);
}
.slide-top-enter, .slide-bottom-leave-active{
  opacity : 0;
  transform : translate(0, 100%);
}
.slide-top-leave-active, .slide-bottom-enter{
  opacity: 0;
  transform: translate(0, -100%);
}
</style>



// WEBPACK FOOTER //
// src/App.vue